import { Badge, Flex, Grid, Loader } from "@aws-amplify/ui-react";
import { CCard } from "@coreui/react";
import { useEffect, useState } from "react";
import LocalizedStrings from "react-localization";
import toast from "react-hot-toast";
import { API, graphqlOperation } from "aws-amplify";

import { sparesByEquipmentID, sparesByServiceOrderID } from "graphql/queries";

const SparesInfo = ({ equipmentID, serviceOrderID }) => {
  const [spares, setSpares] = useState({ data: [], loading: false });

  const getSparesData = async (id, byServiceOrder = false) => {
    try {
      setSpares({ data: [], loading: true });

      let query = sparesByEquipmentID;
      let queryName = "sparesByEquipmentID";

      if (byServiceOrder) {
        query = sparesByServiceOrderID;
        queryName = "sparesByServiceOrderID";
      }

      const sparesData = await API.graphql(
        graphqlOperation(query, {
          ...(byServiceOrder ? { serviceOrderID: id } : { equipmentID: id }),
          filter: {
            deletedAt: { attributeExists: false },
          },
        })
      );
      const sparesItems = sparesData.data[queryName].items;

      setSpares((prev) => ({ ...prev, data: sparesItems }));
    } catch (err) {
      toast.error(strings.errors.fetchSpares);
    } finally {
      setSpares((prev) => ({ ...prev, loading: false }));
    }
  };

  useEffect(() => {
    if (serviceOrderID) getSparesData(serviceOrderID, true);
    else if (equipmentID) getSparesData(equipmentID);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [equipmentID]);

  return (
    <CCard
      className="p-3"
      borderRadius="medium"
      variation="outlined"
      style={{ height: "100%" }}
    >
      <Grid gap="5px">
        <span className="fs-5">
          {serviceOrderID ? strings.sparesService : strings.sparesEquipment}
        </span>
        {spares.loading ? (
          <Loader />
        ) : spares.data.length > 0 ? (
          <Flex rowGap="10px" columnGap="10px" wrap="wrap">
            {spares.data.map((spare, index) => (
              <Badge key={index}>{spare.name}</Badge>
            ))}
          </Flex>
        ) : (
          strings.noSpares
        )}
      </Grid>
    </CCard>
  );
};

const strings = new LocalizedStrings({
  es: {
    sparesEquipment: "Repuestos del Equipo",
    sparesService: "Repuestos de la Orden",
    name: "Nombre",
    description: "Descripción",
    location: "Ubicación",
    errors: {
      fetchSpares: "Error al consultar los repuestos",
    },
    noSpares: "Sin repuestos...",
  },
});

export default SparesInfo;
